import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { ButtonGroup, Clue, url } from "lcm-iot-commons";

export default function NoTenants() {
  const intl = useIntl();

  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; id: string; title: stri... Remove this comment to see the full error message
    <Clue
      id="no-tenants-found"
      title={intl.formatMessage({ id: "tenants.no_tenants_found" })}
      details={intl.formatMessage({
        id: "tenants.no_tenants_found.ask_create",
      })}
      className="notification"
      highlighted
    >
      <ButtonGroup>
        <Link className="btn btn-primary" to={url("/tenants/create")}>
          {intl.formatMessage({ id: "button.create_tenant" })}
        </Link>
      </ButtonGroup>
    </Clue>
  );
}
